// Календарь
export default class Calendar {
    constructor(id, mounth = false, year = false, paymentObject = false) {
        this.payment = paymentObject;
        this.idContainer = id;
        this.monthes = [
            "Январь",
            "Февраль",
            "Март",
            "Апрель",
            "Май",
            "Июнь",
            "Июль",
            "Август",
            "Сентябрь",
            "Октябрь",
            "Ноябрь",
            "Декабрь",
        ];

        this.weekDays = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];
        this.maxWeekDays = this.weekDays.length;

        this.date = new Date();
        this.today = this.date.getDate();
        let staticDate = this.getMinStaticDateForOrder();
        this.staticMinDateMounth = staticDate.mounth - 1;
        this.staticMinDateYear = staticDate.year;

        this.currentMonth =
            mounth || mounth === 0 ? mounth : this.staticMinDateMounth;

        this.currentYear = year ? year : this.staticMinDateYear;

        this.tempDate = new Date(this.currentYear, this.currentMonth + 1, 0);
        this.lastDay = this.tempDate.getDate();

        this.maxMonth = this.monthes.length;

        this.currWeekDay = this.date.getDay();
        this.firstDay = new Date(this.currentYear, this.currentMonth, 1);
        this.firstDayWeek = this.firstDay.getDay();
        this.next;
        this.calendar = document.createElement("div");
        this.calendar.classList.add("calendar");
        this.t = this.firstDayWeek - 1;
        if (this.t < 0) {
            this.t = 6;
        }
    }

    createMonth() {
        let inst = this;
        let mounthContainer = document.createElement("div");
        mounthContainer.classList.add(
            "sect",
            "grid-x",
            "grid-padding-x",
            "align-justify",
            "align-middle"
        );
        if (
            this.staticMinDateMounth < this.currentMonth ||
            this.staticMinDateYear < this.currentYear
        ) {
            let leftArrow = document.createElement("div");
            leftArrow.classList.add("cell", "shrink");

            let linkLeftArrow = document.createElement("a");
            linkLeftArrow.classList.add("calendar-month-link");
            linkLeftArrow.innerHTML = "<i class='fas fa-chevron-left'>";
            leftArrow.appendChild(linkLeftArrow);

            linkLeftArrow.addEventListener("click", function(e) {
                e.preventDefault();

                let prevMounth = inst.currentMonth - 1;
                let prevYear = inst.currentYear;

                if (prevMounth < 0) {
                    prevMounth = 11;
                    prevYear = parseInt(prevYear) - 1;
                } else {
                    prevMounth = inst.currentMonth - 1;
                }

                let nextCalendar = new Calendar(
                    inst.idContainer,
                    prevMounth,
                    prevYear,
                    inst.payment
                );
                nextCalendar.init();
            });
            mounthContainer.appendChild(leftArrow);
        }

        let rightArrow = document.createElement("div");
        rightArrow.classList.add("cell", "shrink");

        let linkRightArrow = document.createElement("a");
        linkRightArrow.classList.add("calendar-month-link");
        linkRightArrow.innerHTML = "<i class='fas fa-chevron-right'>";
        rightArrow.appendChild(linkRightArrow);

        linkRightArrow.addEventListener("click", function(e) {
            e.preventDefault();

            let nextMounth = inst.currentMonth + 1;
            let nexYear = inst.currentYear;
            if (nextMounth > 11) {
                nextMounth = 0;
                nexYear = parseInt(nexYear) + 1;
            } else {
                nextMounth = inst.currentMonth + 1;
            }

            let nextCalendar = new Calendar(
                inst.idContainer,
                nextMounth,
                nexYear,
                inst.payment
            );

            nextCalendar.init();
        });

        let mounthName = document.createElement("div");
        mounthName.classList.add("cell", "auto", "calendar-month-title");

        //  if (this.currentYear != this.date.getFullYear()) {
        this.monthes[this.currentMonth] =
            this.monthes[this.currentMonth] + " " + this.currentYear;
        //  }
        mounthName.innerHTML = this.monthes[this.currentMonth];

        mounthContainer.appendChild(mounthName);
        mounthContainer.appendChild(rightArrow);

        return mounthContainer;
    }

    createWeekDays() {
        let daysContainer = document.createElement("div");
        daysContainer.classList.add("grid-x", "small-up-7", "calendar-days-titles");

        for (var i = 0; i < this.maxWeekDays; i++) {
            let el = document.createElement("div");
            el.classList.add("cell", "calendar-day-title");
            el.innerHTML = this.weekDays[i];
            daysContainer.appendChild(el);
        }

        return daysContainer;
    }

    getMinStaticDateForOrder() {
        let date = null;
        $.ajax({
            method: "POST",
            url: "/themes/ahtilahti/ajax/event_pay.php",
            async: false,
            // dataType: 'json',
            data: {
                action: "get_min_static_date",
                data: {
                    event: this.payment.eventId,
                },
            },
            success: function(response) {
                let res;
                typeof response === "string" ?
                    (res = $.parseJSON(response)) :
                    (res = response);

                if (res.success) {
                    date = res.staticDate;
                }
            },

            error(xhr, status, error) {
                console.log(error);
            },
        });
        return date;
    }
    getDatesForOrder() {
        let mounth = this.currentMonth;
        let year = this.currentYear;
        let elements = [];

        $.ajax({
            method: "POST",
            url: "/themes/ahtilahti/ajax/event_pay.php",
            async: false,
            // dataType: 'json',
            data: {
                action: "get_dates",
                data: {
                    event: this.payment.eventId,
                    mounth: mounth,
                    year: year,
                },
            },
            success: function(response) {
                let res;
                typeof response === "string" ?
                    (res = $.parseJSON(response)) :
                    (res = response);
                if (res.success) {
                    if (Object.keys(res.elements).length > 0) {
                        elements = res.elements;
                    }
                }
            },

            error(xhr, status, error) {
                console.log(error);
            },
        });

        return elements;
    }

    isCurrentDate(year, day, datesForOrder) {
        let currentYear = year;
        let currentDay = day;
        let element = null;

        for (let j = 1; j <= Object.keys(datesForOrder).length; j++) {
            if (
                datesForOrder[j].day == currentDay &&
                datesForOrder[j].year == currentYear
            ) {
                element = {
                    success: true,
                    day: datesForOrder[j].day,
                    year: datesForOrder[j].year,
                    mounth: datesForOrder[j].mounth,
                };
            }
        }

        return element;
    }
    createDays() {
        let instance = this;

        let datesForOrder = this.getDatesForOrder();

        let daysCalendar = document.createElement("div");

        daysCalendar.classList.add("calendar-dates");
        let a = 0;

        while (this.firstDay.getMonth() == this.currentMonth) {
            let i = 0;

            var row = document.createElement("div");
            row.classList.add("grid-x", "small-up-7", "text-center");
            while (i < 7) {
                let col;
                // let day;
                if (a == 0) {
                    if (i < this.t) {
                        col = document.createElement("div");
                        col.classList.add("cell", "calendar-date-disabled");
                        col.innerHTML = "";
                    } else {
                        let elem = this.isCurrentDate(
                            this.currentYear,
                            this.firstDay.getDate(),
                            datesForOrder
                        );
                        if (elem) {
                            // day = this.firstDay.getDate();
                            col = document.createElement("a");
                            col.classList.add("cell", "calendar-date");

                            col.addEventListener("click", function(e) {
                                e.preventDefault();
                                instance.payment.userData.sessionDay = elem.day;
                                instance.payment.userData.sessionYear = elem.year;
                                instance.payment.userData.sessionMounth = elem.mounth;
                                instance.payment.hideStep2();
                                instance.payment.showStep3();
                            });
                        } else {
                            col = document.createElement("div");
                            col.classList.add("cell", "calendar-date-disabled");
                        }

                        col.innerHTML = this.firstDay.getDate();
                        this.firstDay.setDate(this.firstDay.getDate() + 1);
                    }
                } else {
                    if (this.next > this.currentMonth) {
                        break;
                    }

                    let elem = this.isCurrentDate(
                        this.currentYear,
                        this.firstDay.getDate(),
                        datesForOrder
                    );


                    if (elem) {
                        col = document.createElement("a");
                        col.classList.add("cell", "calendar-date");
                        col.setAttribute("data-item", elem.id);
                        // day = this.firstDay.getDate();
                        col.addEventListener("click", function(e) {
                            e.preventDefault();

                            instance.payment.userData.sessionDay = elem.day;
                            instance.payment.userData.sessionYear = elem.year;
                            instance.payment.userData.sessionMounth = elem.mounth;
                            instance.payment.hideStep2();
                            instance.payment.showStep3();
                        });
                    } else {
                        col = document.createElement("div");
                        col.classList.add("cell", "calendar-date-disabled");
                    }

                    col.innerHTML = this.firstDay.getDate();
                    this.firstDay.setDate(this.firstDay.getDate() + 1);
                    this.next = this.firstDay.getMonth();
                }
                row.appendChild(col);
                i++;
            }
            daysCalendar.appendChild(row);
            a++;
        }

        return daysCalendar;
    }

    init() {
        let mounth = this.createMonth();
        let days = this.createDays();
        let weekDays = this.createWeekDays();
        this.calendar.appendChild(mounth);
        this.calendar.appendChild(weekDays);
        this.calendar.appendChild(days);

        $("#" + this.idContainer).html(this.calendar);

    }
}